export default "__VITE_ASSET__Djt7$Ft$__"